import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { CalComponent } from './cal-component/cal-component.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-custom-datepicker',
  templateUrl: './custom-datepicker.component.html',
  styleUrls: ['./custom-datepicker.component.scss']
})
export class CustomDatepickerComponent implements OnInit {

  @ViewChild('calendar') calendar: MatCalendar<Moment>;
  @Input('selectedDate') selectedDate: Moment;

  constructor(@Inject(MAT_DIALOG_DATA) public calData: any,
                 private dialog: MatDialog,
                 public dialogRef: MatDialogRef<CalComponent>
                 ) { }

  ngOnInit(): void {
    if (this.calData?.selectedDate)
    {
      console.log("incoming selected date:" + this.calData.selectedDate);
      this.selectedDate = this.calData.selectedDate;
      try
      {
           this.calendar.activeDate = this.selectedDate;
      }
      catch (Err)
      {}
      
    }
  }

/*  openDialog() {
    const dialogRef = this.dialog.open(CalComponent, {
      width: '20%',
      height: '40%'
    })
    dialogRef.afterClosed().subscribe((result) => {
     console.log("now resetting selected calendar date")
     console.log("result incoming:")
     console.log(result)
     this.ngOnInit();

  });
  }
*/
  customCalBtnDoneClick(evt: Event)
  {
    console.log("captured click for Done: " + evt)

    this.dialogRef.close();
  }

  customCalBtnTodayClick(evt: Event)
  {
    console.log("captured click for Today: " + evt)
    
    this.dialogRef.close({myResult: moment()});
  }

  customCalBtnClearClick(evt: Event)
  {
    console.log("captured click for Clear: " + evt)

    this.dialogRef.close({event:'clear'});
  }


  customCalClick(evt: Event)
  {
    console.log("captured click:" + evt)
    
  }

  dateChanged(evt: Event)
  {
    console.log("selected date change :" + evt)
    
    // this.dateSelected.emit(this.selectedDate);
    this.dialogRef.close({myResult: evt});
  }
}
